export default {
  el: '#app16',
  data() {
    return {
      title: 'Kontak',
      address: 'Jl. Suci No.113 - 114, Susukan, Kec. Ciracas, Kota Jakarta Timur, Daerah Khusus Ibukota Jakarta 13750',
    };
  }
};
